import { Fragment } from 'react';
import { Box, Flex, Text, HStack, VStack, useBreakpointValue, Image } from '@skin-seoul/design-system';
import type { Review, ReviewImage } from '..';
import { StarIcon } from '../assets/icons/StarIcon';
import { ReviewCardImageCarousel } from './ReviewCardImageCarousel';
import { formatRelativeTime } from '../utils';
import avatar from '../assets/images/avatar.png';

interface ReviewCardProps {
  review: Review;
  onImageClick: (image: ReviewImage, index: number) => void;
  isLastInColumn?: boolean;
}
//TODO: need to check which image click for this event
export const ReviewCard = ({ review, onImageClick, isLastInColumn: _isLastInColumn = false }: ReviewCardProps) => {
  // const hasImages = Boolean(review.images && review.images.length > 0);
  const isMobile = useBreakpointValue({ base: true, tablet: false });
  const hasReviewImages = Boolean(review.images && review.images.length > 0);

  return (
    <Flex gap="13px" w="full">
      <Box p={4} borderRadius="8px" border="1px solid #E9EAEB" w="full" flexGrow={1} h="fit-content">
        <VStack gap={4} align="start">
          <HStack justify="space-between" align="center" w="full">
            <HStack gap={1} align="center">
              <Text textStyle="heading.h5" fontWeight="semibold" color="primary.400">
                {review.rating}
              </Text>
              <StarIcon width={20} height={20} />
            </HStack>

            <Text color="neutral.400" textStyle="label.small" fontWeight="normal">
              {formatRelativeTime(review.createdAt)}
            </Text>
          </HStack>
          {isMobile && hasReviewImages && (
            <ReviewCardImageCarousel
              images={review.images || []}
              width="full"
              height="358px"
              onImageClick={onImageClick}
            />
          )}
          <VStack
            gap={{
              base: 4,
              tablet: 3,
            }}
          >
            <VStack
              align="start"
              gap={{
                base: 4,
                tablet: 2,
              }}
            >
              <Text textStyle="paragraph.large" fontWeight="semibold" color="neutral.800">
                {review.title}
              </Text>
              <Text textStyle="paragraph.small" fontWeight="normal" color="neutral.500">
                {review.content}
              </Text>
            </VStack>
            <HStack borderRadius="8px" p={2} bg="neutral.50" w="full" gap={2}>
              <Image src={avatar.src} alt="avatar" w={8} h={8} borderRadius="50%" flexShrink={0} />
              <VStack align="start" gap={0.5}>
                <Text textStyle="label.small" fontWeight="medium" color="neutral.800">
                  {review.author.name}
                </Text>
                <HStack gap={1}>
                  {review.skinType.map((type, index) => (
                    <Fragment key={index}>
                      <Text textStyle="label.xsmall" fontWeight="normal" color="neutral.700">
                        {type}
                      </Text>
                      {index < review.skinType.length - 1 && (
                        <Box w={0.5} h={0.5} bg="neutral.100" borderRadius="50%" />
                      )}
                    </Fragment>
                  ))}
                </HStack>
              </VStack>
            </HStack>
          </VStack>
        </VStack>
      </Box>
      {!isMobile ? (
        hasReviewImages ? (
          <ReviewCardImageCarousel
            images={review.images || []}
            width="279px"
            height="336px"
            onImageClick={onImageClick}
          />
        ) : (
          <Box w="279px" flexShrink={0} />
        )
      ) : null}
    </Flex>
  );
};

export default ReviewCard;
